export const MESSAGE_FIELD_ERROR_NOTIFICATION_ID = 'message-field-error'
